
import React, { useState } from "react";
import Dialog from "../../components/Dialog"
import { AiOutlinePlus, AiOutlineDelete } from "react-icons/ai";
import Imagen1 from "../../assets/images/galeria1.jpg";
import Imagen2 from "../../assets/images/galeria2.jpg";
import Sider from "../../components/siderbarcomponents";

const ImageGallery = () => {
  const [images, setImages] = useState([
    Imagen1,
    Imagen2,
    Imagen1,
    Imagen2,
    Imagen1,
    Imagen2,
  ]);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);


  const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]; // Asegura que files no sea null
    if (file) {
      const newImage = URL.createObjectURL(file);
      setImages((prevImages) => [...prevImages, newImage]); // Forma segura de actualizar el estado
    }
  };
  

  const handleDeleteImage = () => {
    setImages(images.filter((img) => img !== selectedImage));
    setIsOpen(false);
    setSelectedImage(null);
  };

  const confirmDelete = () => {
    setImages(images.filter((img) => img !== selectedImage));
    setIsOpen(false);
  };


  return (
    <div className="flex-col lg:flex-row flex h-screen bg-gray-100 overflow-auto">
      <Sider />
      {/* Contenido principal */}
      <div className="p-12 w-full ">
        <h2 className="text-center text-2xl font-bold mb-4">
          GALERÍA DE IMÁGENES PARA GOBIES
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {images.map((img, index) => (
            <div key={index} className="relative">
              <img
                src={img}
                alt={`uploaded-${index}`}
                className="w-full lg:h-80 h-40 object-cover rounded-lg cursor-pointer"
                onClick={() => {
                  setSelectedImage(img);
                  setIsOpen(true);
                }}
              />
            </div>
          ))}

          <label className="border-2 border-dashed border-gray-400 rounded-lg flex flex-col items-center justify-center h-40 cursor-pointer">
            <AiOutlinePlus className="text-2xl text-gray-600" />
            <span className="text-sm text-gray-600">Click here to upload</span>
            <input
              type="file"
              className="hidden"
              onChange={handleImageUpload}
            />
          </label>
        </div>

        <Dialog
        open={isOpen}
        title="Delete Image"
        description="Are you sure you want to delete this image?"
        onConfirm={confirmDelete}
        onCancel={() => setIsOpen(false)}
      />
      </div>
    </div>
  );
};

export default ImageGallery;
